
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M4.125 10.5H6.75M2 6.5h13m-12.227-3h11.454c.703 0 1.273.56 1.273 1.25v7.5c0 .69-.57 1.25-1.273 1.25H2.773c-.703 0-1.273-.56-1.273-1.25v-7.5c0-.69.57-1.25 1.273-1.25"}})])
          )
        }
      }
    